import { editorPaths, editorsList } from '@common/config'

import type { TEditorsList } from '@common/types'

export function getEditorFromPathname(pathname: string): TEditorsList {
    if (pathname.includes(editorPaths[editorsList.MATCH_EDITOR])) {
        return editorsList.MATCH_EDITOR
    }

    return editorsList.LINEUP_EDITOR
}
